import { guidFor } from '@ember/object/internals';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { modifier } from 'ember-modifier';
import HotelChannelPricingTablesCellsMinorChannelsTablePricesPricingRowCellContent from 'lumen/components/hotel/channel-pricing/tables/cells/minor-channels-table/prices/pricing-row-cell-content';
import HotelChannelPricingTablesCellsMinorChannelsTableRestrictionsRestrictionsRowCellContent from 'lumen/components/hotel/channel-pricing/tables/cells/minor-channels-table/restrictions/restrictions-row-cell-content';
import type {
  TdMinorChannelsTableColumnSignature,
  TdMinorChannelsTableRowSignature,
} from 'lumen/components/hotel/channel-pricing/tables/minor-channels-table';
import { MINOR_CHANNELS_TABLE_ROW_TYPES } from 'lumen/utils/constants/channel-pricing-constants';

import styles from './td-value-cell.module.css';

interface HotelChannelPricingTablesCellsMinorChannelsTableTdValueCellSignature {
  Args: {
    column: TdMinorChannelsTableColumnSignature;
    row: TdMinorChannelsTableRowSignature;
  };
}

export default class HotelChannelPricingTablesCellsMinorChannelsTableTdValueCell extends Component<HotelChannelPricingTablesCellsMinorChannelsTableTdValueCellSignature> {
  @service('channel-pricing/table-hover')
  declare channelPricingTableHover: Services['channel-pricing/table-hover'];

  cellId = `minor-channels-table-value-cell-${guidFor(this)}`;

  handleHoverEventHandlers = modifier((cellWrappingElement) => {
    const mouseEnterHandler = (): void => {
      this.channelPricingTableHover.hoveredColumnId = this.args.column.id;
    };

    const mouseLeaveHandler = (): void => {
      this.channelPricingTableHover.hoveredColumnId = null;
    };

    cellWrappingElement.addEventListener('mouseenter', mouseEnterHandler);
    cellWrappingElement.addEventListener('mouseleave', mouseLeaveHandler);

    return (): void => {
      cellWrappingElement.removeEventListener('mouseenter', mouseEnterHandler);
      cellWrappingElement.removeEventListener('mouseleave', mouseLeaveHandler);
    };
  });

  get isCellOfHoveredColumn(): boolean {
    if (
      this.channelPricingTableHover.hoveredColumnId !== null &&
      this.channelPricingTableHover.hoveredColumnId === this.args.column.id
    ) {
      return true;
    }

    return false;
  }

  get isRestrictionsRow(): boolean {
    return this.args.row.type === MINOR_CHANNELS_TABLE_ROW_TYPES.RESTRICTION;
  }

  <template>
    <div
      class="relative flex h-full flex-row items-center justify-end gap-100
        {{if this.isCellOfHoveredColumn styles.highlighted}}
        {{if @column.isPastDay styles.is-past}}"
      {{this.handleHoverEventHandlers}}
      data-test-id="td-minor-channels-table-value-cell"
    >
      {{#if this.isRestrictionsRow}}
        <HotelChannelPricingTablesCellsMinorChannelsTableRestrictionsRestrictionsRowCellContent
          @column={{@column}}
          @parentCellId={{this.cellId}}
          @row={{@row}}
        />
      {{else}}
        <HotelChannelPricingTablesCellsMinorChannelsTablePricesPricingRowCellContent
          @column={{@column}}
          @row={{@row}}
        />
      {{/if}}
    </div>
  </template>
}
